/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import SearchBox from 'components/New/SearchBox';
import PageTitle from 'components/New/Page/PageTitle';
import classes from './PageHeader.module.scss';

const PageHeader = ({ className = '', title }) => {
  return (
    <div className={cn(classes.wrapper, className)}>
      <PageTitle className={classes.title}>{title}</PageTitle>
      <SearchBox className={classes.searchBox} />
    </div>
  );
};

export default PageHeader;
